import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";

const FAQS = [
  {
    q: "When do new drops go live?",
    a: "Drops are announced first to the email/SMS list and Run Club members. Join the list on the homepage for early links — limited runs sell through fast.",
  },
  {
    q: "How does TRAILNONE fit?",
    a: "Our cuts run oversized by design. Check the size chart on any product page — if you want a regular fit, size down once.",
  },
  {
    q: "How long does shipping take?",
    a: "Orders are processed within 2 business days. Standard shipping typically lands in 3–7 business days domestically. Every order over $150 ships free.",
  },
  {
    q: "What's the return policy?",
    a: "30 days, unworn, tags attached. Start a return from the Shipping & Returns page or reply to your order confirmation email.",
  },
  {
    q: "Do you ship internationally?",
    a: "Yes — duties and taxes are calculated at checkout where available so there are no surprises at the door.",
  },
  {
    q: "How do I track my order?",
    a: "You get a carrier tracking link by email the moment your order ships. You can also check status any time on the Track Order page or inside your account.",
  },
  {
    q: "How do I join the Run Club?",
    a: "Head to the Run Club page and drop your email — you'll get the weekly route, start point and member-only drop codes.",
  },
  {
    q: "Are restocks a thing?",
    a: "Limited runs usually don't restock. Core pieces do. The list hears first either way.",
  },
];

export default function FAQ() {
  return (
    <div>
      <PageHeader
        eyebrow="Answers"
        title="FAQ"
        description="The questions the crew asks most. Anything else — hit the contact page."
      />
      <div className="px-5 py-12 sm:px-10 lg:px-16">
        <Reveal>
          <div className="max-w-3xl" data-testid="faq-accordion">
            <Accordion type="single" collapsible>
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left font-display text-base font-semibold uppercase tracking-wide">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
